import { Routes, Route, BrowserRouter, useLocation } from 'react-router-dom';
import * as React from 'react';
import Loading from './components/Loading/Loading';
import './App.css';
import Footer from './components/Footer/Footer';
import NavBar from './components/NavBar/NavBar';
import Landing from './components/pages/Landing';
import { trackPageview } from './lib/analytics';

const CardProduct = React.lazy(() => import('./components/CardProduct/CardProduct'));
const TeamPage = React.lazy(() => import('./components/pages/Team'));

function RouteTracker() {
  const location = useLocation();

  React.useEffect(() => {
    trackPageview(location.pathname);
  }, [location.pathname]);

  return null;
}

function App() {
  return (


    <BrowserRouter>
      <RouteTracker />
      <NavBar />
      <React.Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/productos/:product" element={<CardProduct />} />
          <Route path="/teamSertex" element={<TeamPage />} />
        </Routes>
      </React.Suspense>
      <Footer />
    </BrowserRouter>

  );
}

export default App;
